import React from 'react'
import { Link } from 'gatsby'
import cx from 'classnames'

import ArrowSvg from './../../graphics/arrow-button-link.svg'

import styles from './styles.module.scss'

const ButtonPrimary = ({ className, label, link, size }) => {

    const buttonClasses = cx({
        'button': true,
        [styles['button-primary']]: true,
        [styles['button-primary--large']]: size == 'large'
    })

    const labelClasses = cx({
        [styles['button-primary__label']]: true,
        [styles['button-primary__label--large']]: size == 'large'
    })
    
    const buttonInner = () => {
        return (
            <>
                <div className={`icon-wrapper ${styles['button-primary__icon-wrapper']}`}>
                    <ArrowSvg className={styles['button-primary__icon']} />
                </div>
                <span className={labelClasses}>{label}</span>
            </>
        )
    }

    if (label == 'Subscribe') {
        return (
            <button className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </button>
        )
    }

    if (!link) return <p>Please add information to the button</p>

    if (link.linktype == 'asset') {
        return (
            <a href={link.cached_url} target='_blank' className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </a>
        )
    } else if (link.linktype === 'url') {
        return (
            <a href={link.cached_url} target='_blank' className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </a>
        )
    } else if (link.linktype === 'email') {
        return (
            <a href={`mailto:${link.email}`} className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </a>
        )
    } else if (link.linktype === 'inner') {
        return (
            <button className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </button>
        )
    } else {
        return (
            <Link to={link ? `/${link.cached_url}` : '/'} className={`${buttonClasses} ${className || ''}`}>
                {buttonInner()}
            </Link>
        )
    }

}

export default ButtonPrimary
